import { useEffect } from 'react';
export const useScroll = ({ open, callback }) => {
    useEffect(() => {
        if (!open)
            return;
        /**
         * Usually, listening to window scroll is sufficient for the Popover.
         * But when the Popover is part of the one-layer dialog, the scroll happens on
         * the element with '[data-scroll-context="true"]'.
         */
        const scrollableOneLayerElement = document.querySelector('[data-scroll-context="true"]');
        window.addEventListener('scroll', callback);
        scrollableOneLayerElement?.addEventListener('scroll', callback);
        return () => {
            window.removeEventListener('scroll', callback);
            scrollableOneLayerElement?.removeEventListener('scroll', callback);
        };
    }, [open, callback]);
};
//# sourceMappingURL=use-scroll.js.map